import { render, staticRenderFns } from "./callMe.vue?vue&type=template&id=7b645028&scoped=true&"
import script from "./callMe.vue?vue&type=script&lang=js&"
export * from "./callMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b645028",
  null
  
)

export default component.exports